/* eslint-disable sort-keys-fix/sort-keys-fix */
import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';
import { DATE_TIME_ISO_SCHEMA } from '../rxdb.constants';

const valueSchema = {
  anyOf: [
    { type: 'string' },
    { type: 'number' },
    { type: 'boolean' },
    { type: 'object', properties: {}, additionalProperties: true },
    {
      type: 'array',
      items: {
        anyOf: [
          { type: 'string' },
          { type: 'number' },
          { type: 'boolean' },
          { type: 'object', properties: {}, additionalProperties: true },
          { type: 'null' },
        ],
      },
    },
    { type: 'null' },
  ],
};

const questionnaireResponseSchemaLiteral = {
  title: 'Questionnaire Response',
  version: 0,
  description: 'Schema for questionnaire responses',
  primaryKey: 'uniqueId',
  type: 'object',
  properties: {
    explanationHtml: { type: ['string', 'null'] },
    id: { type: 'string' },
    uniqueId: { type: 'string', maxLength: 100 },
    createdAt: DATE_TIME_ISO_SCHEMA,
    updatedAt: DATE_TIME_ISO_SCHEMA,
    aiRequestId: { type: ['string', 'null'] },
    associatedWithId: { type: ['string', 'null'] },
    hasAutofillRun: { type: 'boolean' },
    index: { type: 'number' },
    value: valueSchema,
    visible: { type: 'boolean' },
    fieldTemplate: {
      type: 'object',
      properties: {
        aiDeduplicationLogic: { type: ['string', 'null'] },
        key: { type: 'string' },
        label: { type: 'string' },
        options: {
          anyOf: [
            {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  key: { type: 'string' },
                  label: { type: 'string' },
                  isDefault: { type: 'boolean' },
                  pdfFillKey: { type: 'string' },
                },
                additionalProperties: true,
              },
            },
            {
              type: 'object',
              properties: {},
              additionalProperties: true,
            },
            { type: 'null' },
          ],
        },
        type: { type: 'string' },
        id: { type: 'string' },
        listFieldTemplateId: { type: ['string', 'null'] },
      },
      additionalProperties: true,
    },
    fieldTemplateId: { type: 'string' },
    source: { type: 'string' },
    sourceId: { type: ['string', 'null'] },
    sourceIndex: { type: ['number', 'null'] },
    submittedById: { type: ['string', 'null'] },
    listRowResponseId: { type: ['string', 'null'] },
    questionnaireId: { type: 'string', maxLength: 100 },
    listResponses: {
      type: ['array', 'null'],
      items: {
        type: 'object',
        properties: {
          updatedAt: DATE_TIME_ISO_SCHEMA,
          id: { type: 'string' },
          associatedWithId: { type: ['string', 'null'] },
          index: { type: 'number' },
          visible: { type: 'boolean' },
          aiRequestId: { type: ['string', 'null'] },
          fieldTemplateId: { type: 'string' },
          source: { type: 'string' },
          sourceId: { type: ['string', 'null'] },
          sourceIndex: { type: ['number', 'null'] },
          listRowResponseId: { type: ['string', 'null'] },
          hasAutofillRun: { type: 'boolean' },
          explanationHtml: { type: ['string', 'null'] },
          value: valueSchema,
        },
      },
    },
  },
  required: ['id', 'uniqueId', 'createdAt', 'updatedAt', 'questionnaireId'],
  indexes: ['questionnaireId'],
} as const;

const schemaTyped = toTypedRxJsonSchema(questionnaireResponseSchemaLiteral);

export type RxQuestionnaireResponseDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const questionnaireResponseSchema: RxJsonSchema<RxQuestionnaireResponseDocType> = questionnaireResponseSchemaLiteral;
